import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'tool-tip-specs',
  templateUrl: './tool-tip-specs.component.html',
  styleUrls: ['./tool-tip-specs.component.sass']
})
export class ToolTipSpecsComponent implements OnInit {
  public component = window.location.protocol + '//' + window.location.host + '/design-specs-measure/tooltip/';
  constructor() { }

  ngOnInit(): void {
  }

  clickEvent(route) {
    if(route == 'light') {
      window.open(this.component, "_blank");
    }
  }
}
